
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/userlist/[uuid]",
      function () {
        return require("private-next-pages/userlist/[uuid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/userlist/[uuid]"])
      });
    }
  